import { clsx } from 'clsx';

interface OrderStatusBadgeProps {
  status: string;
  statusName: string;
}

function getStatusColor(status: string): string {
  switch (status) {
    case 'N':
      return 'bg-blue-100 text-blue-800';
    case 'P':
      return 'bg-yellow-100 text-yellow-800';
    case 'F':
      return 'bg-green-100 text-green-800';
    case 'DF':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function OrderStatusBadge({ status, statusName }: OrderStatusBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        getStatusColor(status)
      )}
    >
      {statusName}
    </span>
  );
}
